var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8441 15.7188H21.2602C21.1702 15.7188 21.0842 15.7577 21.0236 15.8257L16.7431 20.732V9.78179C16.7431 9.69623 16.6727 9.62622 16.5866 9.62622H15.4134C15.3273 9.62622 15.2569 9.69623 15.2569 9.78179V20.732L10.9764 15.8257C10.9178 15.7577 10.8317 15.7188 10.7398 15.7188H9.15593C9.02295 15.7188 8.9506 15.8763 9.0386 15.9755L15.5287 23.4137C15.5874 23.481 15.6599 23.535 15.7414 23.572C15.8229 23.609 15.9114 23.6281 16.001 23.6281C16.0905 23.6281 16.1791 23.609 16.2605 23.572C16.342 23.535 16.4146 23.481 16.4732 23.4137L22.9614 15.9755C23.0494 15.8743 22.977 15.7188 22.8441 15.7188Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.6272C31.5 25.1889 24.5603 32.1294 16 32.1294C7.43965 32.1294 0.5 25.1889 0.5 16.6272C0.5 8.06551 7.43965 1.125 16 1.125C24.5603 1.125 31.5 8.06551 31.5 16.6272Z",
    stroke: "white",
    strokeOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/DownIcon.1572f5f3.svg";
export { ForwardRef as ReactComponent };